import { HeaderModal } from './types';

export const headers: HeaderModal = {
  Accept: 'application/json',
  'Content-Type': 'application/json',
  platform: 'web',
  device: 'web',
  'X-Locale': 'de',
};

export const CLIENT_ID_LOGIN = 'bluemovie-web';
export const CLIENT_STATE_LOGIN = '123456789';
